import { render, staticRenderFns } from "./BorrowingHistories.vue?vue&type=template&id=3fb333b8&"
import script from "./BorrowingHistories.vue?vue&type=script&lang=js&"
export * from "./BorrowingHistories.vue?vue&type=script&lang=js&"
import style0 from "./BorrowingHistories.vue?vue&type=style&index=0&id=3fb333b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports